var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundIsotipoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 489,
    viewBox: "0 0 388 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0031 294.72C22.2414 294.72 0.447266 272.854 0.447266 246.004C0.447266 219.154 22.2414 197.288 49.0031 197.288H339.444C366.206 197.288 388 219.154 388 246.004C388 272.854 366.206 294.72 339.444 294.72H49.0031Z",
    fill: "#755DDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.805 96.8032C180.261 96.8032 168.894 90.607 158.422 80.1454C147.994 69.6838 136.762 64.1612 122.441 64.1612C108.12 64.1612 97.4694 69.1901 86.1024 80.5946C74.7354 91.999 64.4423 96.8032 50.1664 96.8032C23.4942 96.8032 1.92383 75.1166 1.92383 48.4015C1.92383 21.6863 23.5389 -3.05176e-05 50.1664 -3.05176e-05C64.5765 -3.05176e-05 75.4066 5.47781 86.2813 16.3884C97.1113 27.2541 108.031 32.6866 122.441 32.6866C136.851 32.6866 147.502 27.5683 158.959 16.0741C170.415 4.5798 180.574 -3.05176e-05 194.805 -3.05176e-05C221.477 -3.05176e-05 243.048 21.6863 243.048 48.4015C243.048 75.1166 221.432 96.8032 194.805 96.8032Z",
    fill: "#755DDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6455 489C21.7942 489 0 467.089 0 440.194C0 413.3 21.839 391.389 48.6455 391.389H196.372C223.223 391.389 245.017 413.3 245.017 440.194C245.017 467.089 223.178 489 196.372 489H48.6455Z",
    fill: "#755DDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.31 391.883C365.954 391.883 387.553 413.553 387.553 440.284C387.553 467.016 365.954 488.686 339.31 488.686C312.667 488.686 291.067 467.016 291.067 440.284C291.067 413.553 312.667 391.883 339.31 391.883Z",
    fill: "#755DDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.594 96.2195C299.883 96.2195 291.962 88.2723 291.962 78.5291V18.2741C291.962 8.53087 299.883 0.583649 309.594 0.583649H369.965C379.676 0.583649 387.597 8.53087 387.597 18.2741V78.5291C387.597 88.2723 379.676 96.2195 369.965 96.2195H309.594Z",
    fill: "#755DDF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIsotipoDark);
export default __webpack_public_path__ + "static/media/background_isotipo_dark.305481a40fe0a409c6cd50e39459a04e.svg";
export { ForwardRef as ReactComponent };